import { DateTime, IANAZone } from 'luxon';

export function getCurrentDate() {
    return DateTime.now().startOf('day').toJSDate();
}

export function getCurrentTimeOffset() {
    const ianaZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return IANAZone.create(ianaZone).offset(Date.now());
}

export function isValidDate(value?: Date) {
    return value != null && !isNaN(value.getTime());
}

export function addMonths(date: Date, diff: number) {
    const day = date.getDate();
    let month = date.getMonth();
    let year = date.getFullYear();

    const diffSign = Math.sign(diff);
    const diffAbsValue = Math.floor(Math.abs(diff));
    const diffAbsMonths = diffAbsValue % 12;
    const diffAbsYears = Math.floor(diffAbsValue / 12)

    year += diffAbsYears * diffSign;
    month += diffAbsMonths * diffSign;
    if (month > 11) {
        month -= 12;
        year += 1;
    } else if (month < 0) {
        month += 12;
        year -= 1;
    }

    return new Date(year, month, day);
}

export const addDays = (date: Date, days: number): Date => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
};

export function diffMonths(startDate: Date, endDate: Date) {
    return DateTime.fromJSDate(endDate).diff(DateTime.fromJSDate(startDate), 'months').months;
}

export function diffMonthsFromToday(endDate: Date): number {
    return DateTime.fromJSDate(endDate).diff(DateTime.now().startOf('day'), 'months').months;
}
